import { TableBordero } from "./table/TableBordero";

export const PageBordero = () => {
  return <TableBordero />;
};
